import * as Sentry from "@sentry/react"
import type { UserService } from "@duck/api-definitions"
import { isClientDevEnv } from '@/client-env'

export const initSentry = () => Sentry.init({
  dsn: "https://b28de227ec4f9431e1e3a637b4e2cfaf@o4510291589529600.ingest.de.sentry.io/4510354690605136",
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error", "info"] }),
  ],
  enableLogs: true,
  release: `client@${import.meta.env.VITE_DEPLOYMENT_TAG}`,
  enabled: !isClientDevEnv,
  // enabled: true,
  environment: import.meta.env.VITE_NODE_ENV,
  sendDefaultPii: false,
})

/**
 * Identifies the current user in Sentry for error tracking and session replay
 * @param user - The user object containing identification information
 */
export const identifyUserInSentry = (user: UserService.User) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.email, // Use email as username
    // Additional context that can be useful for debugging
    firstName: user.firstName,
    lastName: user.lastName,
    role: user.role,
  })
}

/**
 * Clears the current user identification in Sentry
 */
export const clearUserInSentry = () => {
  Sentry.setUser(null)
}